import React from "react";

function Contact() {
  return (
    <section id="contact" className="gradient-bg text-white section-padding">
      <section>
          <div className="container text-center">
              <h2 className="fw-bold mb-4">Partner With Leocord</h2>
              <p className="mb-5">
              Connect with our institutional sales team for product catalogs,
              bulk supply inquiries.
              </p>

              <a href="/contact" className="btn btn-light px-5">
              Contact Sales Team
              </a>
          </div>
      </section>
      <div className="container d-none">
        <h2 className="text-center mb-4">Contact Sales</h2>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <form>
              <div className="row mb-3">
                <div className="col-md-6">
                  <input type="text" className="form-control" placeholder="Full Name" />
                </div>
                <div className="col-md-6">
                  <input type="email" className="form-control" placeholder="Email Address" />
                </div>
              </div>
              <div className="mb-3">
                <textarea className="form-control" rows="4" placeholder="Product Requirement"></textarea>
              </div>
              <div className="text-center">
                <button className="btn btn-light px-4">Submit Inquiry</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;

